import { IconButton } from "@chakra-ui/react";
import { BsThreeDotsVertical } from "react-icons/bs";
import { MenuContent, MenuRoot, MenuTrigger } from "../ui/menu";
import type {
  TablePublic,
  TableFieldPublic,
  FeedMetadataPublic,
  OpenSearchDoc,
} from "@/client";

import EditTable from "../Tables/EditTable";
import DeleteTable from "../Tables/DeleteTable";
import EditTableField from "../TableFields/EditTableField";
import DeleteTableField from "../TableFields/DeleteTableField";
import EditTableRow from "../TableRows/EditTableRow";
import DeleteTableRow from "../TableRows/DeleteTableRow";
import EditFeed from "../Reports/EditFeed";
import DeleteFeed from "../Reports/DeleteFeed";

interface ActionsMenuProps {
  table?: TablePublic;
  tableField?: TableFieldPublic;
  openSearchDoc?: OpenSearchDoc;
  feed?: FeedMetadataPublic;
  tableId?: string;
  currentPage?: number;
  totalCount?: number;
  onPageChange?: (page: number) => void;
}

export const ActionsMenu = ({
  table,
  tableField,
  openSearchDoc,
  feed,
  tableId,
  currentPage,
  totalCount,
  onPageChange,
}: ActionsMenuProps) => {
  return (
    <MenuRoot>
      <MenuTrigger asChild>
        <IconButton 
          variant="ghost"
          color="inherit"
          onClick={(e) => e.stopPropagation()}
        >
          <BsThreeDotsVertical />
        </IconButton>
      </MenuTrigger>
      <MenuContent>
        {table ? (
          <>
            <EditTable table={table} />
            <DeleteTable id={table.id} />
          </>
        ) : tableField ? (
          <>
            <EditTableField tableField={tableField} />
            <DeleteTableField
              id={tableField.id}
              currentPage={currentPage || 1}
              totalCount={totalCount || 0}
              onPageChange={onPageChange}
            />
          </>
        ) : openSearchDoc && tableId ? (
          <>
            <EditTableRow tableId={tableId} openSearchDoc={openSearchDoc} />
            <DeleteTableRow tableId={tableId} tableRowId={openSearchDoc.id} />
          </>
        ) : feed ? (
          <>
            <EditFeed feed={feed} />
            <DeleteFeed id={feed.id} />
          </>
        ) : null}
      </MenuContent>
    </MenuRoot>
  );
};
